<template>
  <div :class="settings.divClass">
    <vx-card :title="settings.label">
      <aron-table
        uploadEndpoint="/uploadFile"
        :endPoint="route"
        :filterEndpoint="filterEndpoint"
        :key="route"
        :formType="formType"
        :filter="filter"
        :viewOnly="viewOnly"
        :showFilter="showFilter"
        :showEditBtn="showEditBtn"
        :showActionButton="showActionButton"
      ></aron-table>
    </vx-card>
  </div>
</template>
 
<script>
import AronTable from "../../table/tblmain.vue";
export default {
  components: {
    AronTable,
  },
  props: {
    settings: Object,
    default: {},
  },
  data() {
    return {
      showActionButton: false,
      showEditBtn: false,
      showFilter: false,
      viewOnly: true,
      route: "search_thecases",
      formType: "sidebarRightSide",
      filterEndpoint: "search_thecases",
      filter: {
        advanceFilter: {
          status: 1,
        },
        limitRecord: 5,
      },
    };
  },
  mounted() {
    console.log("settings:", this.settings);
    if (this.settings.hasOwnProperty("clientId")) {
      this.filter.advanceFilter["clientId"] = this.settings.clientId;
    }
  },
};
</script>